import { Box, Container, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { m } from 'framer-motion';
import { useRef } from 'react';
import { CityAgentCard } from 'src/components/agent/city-agent-card';
import { MotionViewport, varContainer, varFade } from 'src/components/animate';
import { Image } from 'src/components/image';
import { themeConfig } from 'src/theme';
import { PROVINCES } from 'src/utils/consts';

export const AgentNetwork = () => {
  const scrollRef = useRef(null);
  return (
    <Box ref={scrollRef} component={m.div} variants={varContainer()}>
      <div className="relative">
        <Box
          sx={{
            borderRadius: {
              xs: '24px 24px 0 0',
              md: '50px 50px 0 0',
            },
            overflow: 'hidden',
          }}
        >
          <Image
            src="/assets/images/image-bus-1.webp"
            alt="Promo Puspa Jaya"
            sx={{
              width: '100%',
            }}
          />
        </Box>
        <div className="absolute inset-0" />
      </div>

      <Box
        sx={{
          borderRadius: {
            xs: '24px',
            md: '50px',
          },
          padding: { xs: '38px 12px', md: '100px' },
          mt: {
            xs: '-20px',
            md: '-50px',
          },
          position: 'relative',
          zIndex: 10,
          background: themeConfig.gradient.primary.bold,
        }}
      >
        <Container>
          <Typography
            variant="h3"
            component="h2"
            color="white"
            textAlign="center"
            sx={{ mb: { xs: '24px', md: '78px' } }}
          >
            Jaringan Agen Puspa Jaya
          </Typography>
          <Grid container spacing={{ xs: '16px', md: 2 }}>
            {PROVINCES.map((e, i) => (
              <Grid size={{ xs: 6, md: 3 }} key={i}>
                <Box
                  component={MotionViewport}
                  variants={varFade('inUp')}
                  viewport={{ root: scrollRef, once: true, amount: 0.1 }}
                >
                  <CityAgentCard image_asset={e.image_asset} name={e.name} />
                </Box>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>
    </Box>
  );
};
